import styled from 'styled-components';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { H5 } from '@finect/tabular-core/Headings';
export var Title = styled(H5).withConfig({
  displayName: "Title",
  componentId: "sc-1ls2dn0-0"
})(["display:block;font-size:22px;font-weight:700;", ";"], textEllipsis);
export var Subtitle = styled.div.withConfig({
  displayName: "Title__Subtitle",
  componentId: "sc-1ls2dn0-1"
})(["display:block;"]);